import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';

export const TableBodyRow = styled.tr`
  /* Use for tbody rows with invalid/highlighted classes (including rows rendered from child files). */
  &.invalid td {
    position: relative;
    background: rgba(255, 241, 241, 0.5) !important;
  }

  &.invalid .fa-row-warning {
    position: absolute;
    top: 1px;
    left: -5px;
    font-size: 12px;
    z-index: ${Theme.z.foreground};
  }

  &.highlighted td {
    position: relative;
    background: #fff9f2 !important;
  }
`;

export const TableWrapper = styled.table`
  width: 100%;

  input {
    margin: 0;
  }

  thead {
    font-size: 13px;
  }

  th {
    padding: 0 3px;
    background: #ccc;
    text-align: left;
  }

  th.sortable {
    cursor: pointer;
    padding-left: 10px;
  }

  th.sortable:hover {
    background: #e0e0e0;
  }

  th.highlighted {
    background: #a7a7a7;
    position: relative;
    padding-left: 20px;
  }

  th.highlighted.ascending:before,
  th.highlighted.descending:before {
    font-family: FontAwesome;
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    color: #333;
    font-size: 18px;
    padding-right: 0.5em;
    position: absolute;
    top: 0;
    left: 5px;
  }

  th.highlighted.ascending:before {
    content: '\\f0d7';
  }

  th.highlighted.descending:before {
    content: '\\f0d8';
  }

  th i {
    margin-top: 5px;
  }

  th select,
  td select {
    margin: 0;
  }

  select {
    height: 35px;
  }

  td {
    background: #fff;
    border-right: none;
    padding: 10px 3px;
    border-bottom: 1px solid #ccc;
    font-size: 14px;
    line-height: 17px;
    font-family: arial, sans-serif;
    vertical-align: middle;
  }

  img {
    max-width: 150px;
  }

  .text {
    position: relative;
  }

  td .text {
    max-width: 600px;
    width: 100%;
  }
`;
